<nb-card class="kpi-tiles-config-dialog">
  <nb-card-header>{{ 'KPI.CONFIGURE_TILES.TITLE' | translate }}</nb-card-header>
  <nb-card-body>
    <p class="text-muted">{{ 'KPI.CONFIGURE_TILES.DESCRIPTION' | translate:{ max: maxTiles } }}</p>
    <p class="selection-count mb-3">
      {{ 'KPI.CONFIGURE_TILES.SELECTED_COUNT' | translate:{ count: workingSelection.size, max: maxTiles } }}
    </p>

    <div class="metric-list">
      <label
        class="metric-option"
        *ngFor="let key of catalogKeys"
        [class.selected]="isSelected(key)"
        [class.disabled]="!isSelected(key) && workingSelection.size >= maxTiles">
        <input
          type="checkbox"
          [checked]="isSelected(key)"
          [disabled]="!isSelected(key) && workingSelection.size >= maxTiles"
          (change)="toggleKey(key)" />
        <span class="metric-info">
          <span class="metric-name">{{ metricLabelKey(key) | translate }}</span>
          <span class="metric-group text-muted">{{ metricGroupKey(key) | translate }}</span>
        </span>
      </label>
    </div>
  </nb-card-body>
  <nb-card-footer class="d-flex justify-content-end gap-2">
    <button type="button" class="btn btn-outline-secondary" (click)="cancel()">
      {{ 'KPI.CONFIGURE_TILES.CANCEL' | translate }}
    </button>
    <button type="button" class="btn btn-primary" (click)="save()">
      {{ 'KPI.CONFIGURE_TILES.SAVE' | translate }}
    </button>
  </nb-card-footer>
</nb-card>
